import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { CustomizedRoundProgressBar } from 'components/common/CustomizedRoundProgressBar/CustomizedRoundProgressBar';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { Pills } from 'components/common/pills/pills';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/customCard/customCard.module.scss';
import { CustomizedTooltip } from 'components/common';

interface Props {
    isStartOverdue: boolean;
    startDate: number;
    isFinishOverdue: boolean;
    endDate: number;
    durationToFixed: number | string;
    floatToFixed: string;
    submittedDurationComplete: number;
}

export const CustomCardMain = ({
    isStartOverdue,
    startDate,
    isFinishOverdue,
    endDate,
    durationToFixed,
    floatToFixed,
    submittedDurationComplete,
}: Props) => {
    return (
        <div data-testid={'custom-card-main'} className={classes.main}>
            <Pills type={isStartOverdue ? 'risk' : undefined}>
                <Icon name={'clock'} size={'1.2rem'} color={'#fd0d1b'} />
                <span>Start: {moment(startDate).format(constants.formats.date.default)}</span>
            </Pills>

            <Pills type={isFinishOverdue ? 'risk' : undefined}>
                <Icon name={'clock'} size={'1.2rem'} color={'#fd0d1b'} />
                <span>End: {moment(endDate).format(constants.formats.date.default)}</span>
            </Pills>

            {(floatToFixed || durationToFixed) && (
                <Pills>
                    {durationToFixed} {floatToFixed}
                </Pills>
            )}

            {!isNaN(Number(submittedDurationComplete)) && (
                <CustomizedTooltip
                    tooltipContent={`Submitted Completion: ${submittedDurationComplete}%`}
                    triggerElement={<CustomizedRoundProgressBar value={Number(submittedDurationComplete)} />}
                />
            )}
        </div>
    );
};
